import { jsx } from 'react/jsx-runtime';
import createSvgIcon from '../../utils/createSvgIcon.js';

var FileExportOutline = createSvgIcon([
    jsx("path", { stroke: "none", d: "M0 0h24v24H0z" }, "0"),
    jsx("path", { d: "M14 3v4a1 1 0 0 0 1 1h4" }, "1"),
    jsx("path", { d: "M11.5 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v5m-5 6h7m-3-3 3 3-3 3" }, "2")
], 'FileExportOutline', { stroke: 'currentColor', strokeLinecap: 'round', strokeWidth: '1.5', fill: 'none', viewBox: '0 0 24 24' });

export { FileExportOutline as default };
